// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FilterIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FilterIcon" ref={forwardedRef} {...props}>
      <path d="M12.25 9.3 17.5 3h-15l5.25 6.3V17l4.5-3zm-3-.543L5.703 4.5h8.594L10.75 8.757v4.44l-1.5 1z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FilterIcon = /* @__PURE__ */ Object.assign(FilterIconComponent, {
  displayName: 'FilterIcon',
});
